export default __webpack_public_path__ + "static/media/centro_atencion.9a8d77af.svg";